export default __webpack_public_path__ + "static/media/Gradiante red - legibility.a68b9122.png";